import { thumbnail } from "Functions/thumbnail";

const renderMultiselect = () => {
    $(".c-aside-filter select")
        .not(".is-loaded")
        .each(function () {
            const $select = $(this);
            let options = {
                templates: {
                    button: '<button type="button" class="multiselect dropdown-toggle" data-toggle="dropdown"><span class="multiselect-selected-text"></span><i class="ico ico-triangle-down is-on-right"></i></button>',
                },
                buttonClass: "c-btn has-icon",
                enableHTML: true,
                enableCollapsibleOptGroups: true,
                collapseOptGroupsByDefault: true,
            };

            if ($select.closest(".c-aside-filter").length) {
                options.templates.filter = `
                <div class="multiselect-item multiselect-filter">
                    <div class="c-form__item c-form__item--text">
                        <input class="c-form__input multiselect-search" type="text">
                        <i class="ico ico-search"></i>
                    </div>
                </div>
            `;
                options.filterPlaceholder = $select.data("filter-text");
                options.enableCaseInsensitiveFiltering = true;
                options.onFiltering = (input) => {
                    const $input = $(input);
                    const $dropdownMenu = $input.closest(".dropdown-menu");

                    if ($input.val()) {
                        $dropdownMenu.addClass("is-filtering");
                    }
                    if (!$input.val()) {
                        $dropdownMenu.removeClass("is-filtering");

                        $dropdownMenu.find("li.multiselect-collapsible-hidden").hide();
                    }
                };
            }

            $select.multiselect(options);
            $select.addClass("is-loaded");
        });

    requestAnimationFrame(() => {
        addMultiselectCounts();
        addFilterAndMore();
    });
};

const addMultiselectCounts = () => {
    $(".c-aside-filter")
        .find("select")
        .each(function () {
            const $select = $(this),
                $options = $select.find("option"),
                $dropdownMenu = $select.next().find(".dropdown-menu"),
                type = $select.data("type");

            $options.each(function () {
                const $option = $(this),
                    count = $option.data("count"),
                    image = $option.attr("image") ? thumbnail($option.attr("image"), "cxs") : false,
                    value = $option.val(),
                    $fakeInput = $dropdownMenu.find('input[value="' + value + '"]'),
                    $fakeInputLabel = $fakeInput.parent();

                if (image) {
                    $fakeInputLabel.prepend('<img src="' + image + '" class="c-img">');
                }

                if ($option.data("r-toggle")) {
                    $fakeInput.attr("r-toggle-trigger", $option.data("r-toggle"));
                }

                if (count && !$fakeInputLabel.find(".count").length) {
                    $fakeInputLabel.append(count);
                    $fakeInput
                        .parents("a")
                        .attr("data-element", "filterItem")
                        .attr("data-type", type)
                        .attr("data-field-value", value)
                        .attr("data-count", count.replace(/<[^>]*>?/gm, "").replace(/[()]/g, ""));
                }
            });
        });
};

const addFilterAndMore = () => {
    $(".c-aside-filter")
        .find('select[type="multiselect"]')
        .each(function () {
            const $dropdownMenu = $(this).next().find(".dropdown-menu");
            const $options = $dropdownMenu.find(".multiselect-group");

            if ($options.length > 0) {
                $dropdownMenu
                    .find(".multiselect-filter")
                    .after(
                        '<div class="multiselect-tabs"><div class="multiselect-tabs__list"></div></div>'
                    );

                $options.each(function (key, item) {
                    $dropdownMenu
                        .find(".multiselect-tabs__list")
                        .append(
                            '<button type="button" class="c-btn js-filter-tab-trigger" data-id="' +
                                $(item).attr("data-id") +
                                '">' +
                                $(item).find("label b").text() +
                                "</button>"
                        );
                });

                $dropdownMenu.find(".js-filter-tab-trigger").on("click", function () {
                    $dropdownMenu.find(".js-filter-tab-trigger.is-active").removeClass("is-active");
                    $(this).addClass("is-active");

                    $dropdownMenu
                        .find("li:not(.multiselect-collapsible-hidden):not(.multiselect-group)")
                        .addClass("multiselect-collapsible-hidden")
                        .hide();

                    $dropdownMenu
                        .find(
                            '.multiselect-group[data-id="' +
                                $(this).attr("data-id") +
                                '"] .caret-container'
                        )
                        .click();
                });

                $dropdownMenu.find(".js-filter-tab-trigger:first-child").click();
            }
        });
};

$(function () {
    renderMultiselect();
});
